export const ACCREDITATIONS_APPLICATIONS = '/accreditations/applications';

export const ACCREDITATIONS_APPLICATIONS_UPLOAD = '/accreditations/applications_historical_data';

export const ORGANIZATIONS = '/organizations';

export const REQUEST = '/request';

export const ORGANIZATIONS_EVALUACTION_DATA = '/organizations/evaluationData';

export const COMMON_POLITICAL_DIVISION = '/common/politicalDivision';

export const DETAILS = '/details';

export const DETAILS_RESPONSIBLE = '/details/responsible';

export const DETAILS_LABORATORY_STAFF = '/details/laboratoryStaff';

export const ANNEXES = '/annexes';

export const ANNEXES_TEST_EQUIPMENT = '/annexes/testEquipment';

export const ANNEXES_PROF_TEST_INTER = '/annexes/profTestInter';

export const ANNEXES_LOCAL = '/annexes/local';

export const COMPLIANCE_COMMITMENT = '/complianceCommitment';

export const SEND_REQUEST = '/sendRequest';